import { Component, computed, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { DialogService, GridContentWidget } from '@eforall/dashboard';
import { DomainDataService } from '../../../../../services';
import { ReadonlyAccessWidget } from "../../../readonly-access/readonly-access.widget";
import { VolunteerDialogDataService } from '../volunteer-dialog-data.service';
import { getSetup } from './grid/get-setup';

@Component({
	selector: 'volunteer-dialog-topics-part',
	standalone: true,
	imports: [
		GridContentWidget,
		ReadonlyAccessWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './topics.part.html',
})
export class VolunteerDialogTopicsPart {

	public dialogBodyHeight = input.required<number>();

	private readonly dialogService = inject(DialogService);
	public readonly dialogDataService = inject(VolunteerDialogDataService);
	private util = inject(UtilityService);
	private readonly domainData = inject(DomainDataService);

	public setup = getSetup(this.dialogDataService, this.util, this.dialogService, this.domainData);

	// subtracting 70 to account for padding, tabstrip, and 45 for readonly access widget if applicable
	public customHeight = computed(() => this.dialogBodyHeight() - 70 - (this.dialogDataService.hasVolunteerEditPermissions() ? 0 : 45));

	public readonly topics = computed(() => this.dialogDataService.volunteerTopics().sort((a, b) => {
		const topicA = this.domainData.data().topicsMap[a.topicId];
		const topicB = this.domainData.data().topicsMap[b.topicId];

		if (!topicA || !topicB) return 0;

		return topicA.order - topicB.order;
	}));

}